import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface AnalyticsReducerState {
  source: string | null;
  medium: string | null;
  content: string | null;
}

const initialState: AnalyticsReducerState = {
  source: null,
  medium: null,
  content: null,
};

const analyticsSlice = createSlice({
  name: "analytics",
  initialState,
  reducers: {
    setSource(state, action: PayloadAction<string | null>) {
      state.source = action.payload;
    },
    setMedium(state, action: PayloadAction<string | null>) {
      state.medium = action.payload;
    },
    setContent(state, action: PayloadAction<string | null>) {
      state.content = action.payload;
    },
  },
});

export const { setSource, setMedium, setContent } = analyticsSlice.actions;

export default analyticsSlice.reducer;
